import type { IOffersSort, TOffersDealType, TOffersSortColumn, TSortDirection } from 'shared/types/buildingOffers';

/**
 * Допустимые направления сортировки колонки (`serp_offers_list.tsx` монолита).
 * get-building-category-offers по убыванию умеет только цену, поэтому площадь и ставка — только по возрастанию
 */
const getSortDirections = (dealType: TOffersDealType, column: TOffersSortColumn): TSortDirection[] =>
  column === 'price' && dealType === 'sale' ? ['asc', 'desc'] : ['asc'];

/**
 * Направление следующего клика: первое допустимое, не равное текущему (`table_list.tsx`).
 * null — колонка не кликабельна: активная сортировка только по возрастанию не сбрасывается, как в монолите
 */
export function getNextSortDirection(
  dealType: TOffersDealType,
  column: TOffersSortColumn,
  sort: IOffersSort | null,
): TSortDirection | null {
  const directions = getSortDirections(dealType, column);

  if (sort?.column !== column) {
    return directions[0];
  }

  return directions.find(direction => direction !== sort.direction) ?? null;
}

export type TOffersApiSort = 'priceAsc' | 'priceDesc' | 'pricePerMeterAsc' | 'areaAsc';

/** Сортировка get-building-category-offers; у аренды колонка цены — ставка за м² */
export function getOffersApiSort(dealType: TOffersDealType, sort: IOffersSort | null): TOffersApiSort | undefined {
  if (!sort) {
    return undefined;
  }

  if (sort.column === 'area') {
    return 'areaAsc';
  }

  if (dealType === 'rent') {
    return 'pricePerMeterAsc';
  }

  return sort.direction === 'desc' ? 'priceDesc' : 'priceAsc';
}
